module.exports = __webpack_public_path__ + "assets/img/image-56-320.26ee9bcb.webp";